document.addEventListener("DOMContentLoaded", function(){
  !function($) {
    'use strict';


    var appModel = {
      camisa: {
        camisasList: [],
        currentCamisa: {}
      },

      map: {

        $markerSelector: jQuery('.marker-selector'),
        markers: [],
        currentMarker: '',

        marker_image: '../images/map-marker.png',
        locations: [
          ['sal', {lat: -31.384423, lng: -57.947755}, '../dist/images/map-marker.png'],
          ['pay', {lat: -32.320513, lng: -58.062870}, '../dist/images/map-marker.png']
        ],

        //Map start init
        mapOptions: {
          // center: new google.maps.LatLng(lat, long),
          zoom: parseInt(15),
          zoomControl: true,
          zoomControlOptions: {
            style: google.maps.ZoomControlStyle.DEFAULT,
          },
          disableDoubleClickZoom: false,
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          },
          scaleControl: true,
          scrollwheel: false,
          streetViewControl: true,
          draggable : true,
          overviewMapControl: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: [{stylers:[{saturation:-100},{gamma:1}]},{elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"poi.business",elementType:"labels.text",stylers:[{visibility:"off"}]},{featureType:"poi.business",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"poi.place_of_worship",elementType:"labels.text",stylers:[{visibility:"off"}]},{featureType:"poi.place_of_worship",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"geometry",stylers:[{visibility:"simplified"}]},{featureType:"water",stylers:[{visibility:"on"},{saturation:50},{gamma:0},{hue:"#50a5d1"}]},{featureType:"administrative.neighborhood",elementType:"labels.text.fill",stylers:[{color:"#333333"}]},{featureType:"road.local",elementType:"labels.text",stylers:[{weight:0.5},{color:"#333333"}]},{featureType:"transit.station",elementType:"labels.icon",stylers:[{gamma:1.5},{saturation:-100}]}]
        },

        googleMap: {}
      }
    };

    window.model = appModel;

    var appController = {
      map: {
        getCurrentMarker: function() {
          return appModel.map.currentMarker;
        },
        init: function($map) {
          appModel.map.googleMap = new google.maps.Map($map.get(0), appModel.map.mapOptions);

          this.createMarkers();
          // addEventListenerMarkers();
          this.setMarker('sal');
        },
        setMarker: function(marker) {
          // this.resetMarkers();
          appModel.map.currentMarker = appModel.map.markers.find(function(elem, index){
            return elem.name == marker;
          });
          if (appModel.map.currentMarker) {
            appModel.map.currentMarker.setMap(appModel.map.googleMap);
            appModel.map.googleMap.setCenter(appModel.map.currentMarker.getPosition());
          }
        },
        createMarkers: function() {
          appModel.map.locations.forEach(function(element, index) {
            var marker = new google.maps.Marker({
              name: element[0],
              position: element[1],
              icon: element[2]
            });
            appModel.map.markers.push(marker);
          });
        },
        resetMarkers: function() {
          appModel.map.markers.forEach(function(marker, i) {
            marker.setMap(null);
          });
        }
      },

      camisa: {
        saveCamisas: function(camisasList) {
          appModel.camisa.camisasList = camisasList;
          appView.camisa.render();
        },
        getCamisas: function() {
          return appModel.camisa.camisasList;
        }
      },

      init: function() {
        appView.init();
      }
    };

    var appView = {
      global: {
        init: function() {
          lightbox.option({
            'albumLabel': 'Imagen %1 de %2'
          });

          $('.slick-album').slick({
            infinite: false,
            dots: true,
            slidesToShow: 3,
            autoplay: true,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: false,
                  dots: true,
                  autoplay: true,
                }
              }
            ]
          });

          var smoothItem = [].slice.call(document.querySelectorAll('.nav-item-smooth'));

          //ScrollSpy SectionContent
          $('body').scrollspy({ target: '#main-navbar' });

          //Navbar items smoothScroll
          for (var i = 0, length = smoothItem.length; i < length; i++) {
            smoothItem[i].addEventListener('click', function(ev) {
              if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                  $('html, body').animate({
                    scrollTop: target.offset().top
                  }, 1000);
                  return false;
                }
              }
            });
          }
        }
      },

      map: {
        init: function() {
          this.$map = $('.map');
          this.$markerSelector = $('.marker-selector');

          //create Google Map
          appController.map.init(this.$map);

          this.$markerSelector.on('click', function(ev) {
            ev.preventDefault();
            var $currentMarker = $(this);
            var markerData = $currentMarker.data('marker');

            appController.map.setMarker(markerData);

            $currentMarker.closest('.col-xs-6').addClass('active').siblings().removeClass('active');
          });

          this.render();
        },
        render: function() {
          var currentHTMLMarker = this.$markerSelector.filter(function(index,el) {
            return $(el).is("[data-marker='" + appController.map.getCurrentMarker().name + "']");
          });
          $(currentHTMLMarker).closest('.col-xs-6').addClass('active').siblings().removeClass('active');
        }
      },

      camisa: {
        init: function() {
          var self = this;

          this.$resultadoBusquedaContent = $('#resultado-busqueda');
          this.$resultadoBusquedaTitle = $('#resultado-busqueda-title');
          this.$buscadorCamisaForm = $('#buscador-camisa');
          this.$contactCamisaForm = $('#contact-camisa');
          this.$modalConsulta = $('#modal-consulta');
          this.$submitButtonBuscador = this.$buscadorCamisaForm.find('button[type="submit"]');
          this.$submitButtonContact = this.$contactCamisaForm.find('button[type="submit"]');
          this.$cancelSubmitButtonContact = this.$contactCamisaForm.find('.cancel-submit');


          //Submit Form buscar Camisa AJAX request
          this.$buscadorCamisaForm.submit(function(ev) {
            ev.preventDefault();

            var response,
                inputsBusqueda = $(this).find('input'),
                data = inputsBusqueda.serialize(),
                url = $(this).attr('action');

            response = $.ajax({
              url: url,
              contentType: "application/x-www-form-urlencoded, charset=UTF-8",
              method: 'POST',
              data: data,
              beforeSend: function(xhr) {
                //check Errors beforeSend
                self.cleanFormBusqueda();
                if (!self.checkInputsBusqueda(inputsBusqueda)) {
                  xhr.abort();
                  self.$submitButtonBuscador.attr({'disabled': false, 'title': 'Buscar'}).removeClass('loading');
                }
              }
            });

            response.done(function(data, textStatus, xhr) {
              //save and show camisas
              self.successResultsBusqueda(data);
              var targetSelector = self.$submitButtonBuscador.data('target');
              var target = $(targetSelector);
              $('html, body').animate({
                scrollTop: target.offset().top - 150
              }, 1000);

              // inputsBusqueda.val('');
            });

            response.fail(function(xhr, textStatus, err) {
              self.errorResultsBusqueda(xhr, inputsBusqueda);
            });
          });


          //Submit Form Contacto Camisa AJAX request
          this.$contactCamisaForm.submit(function(ev) {
            ev.preventDefault();

            var response,
                inputsContacto = $(this).find('.form-control'),
                data = inputsContacto.serialize(),
                url = $(this).attr('action');
            debugger;
            console.log(inputsContacto);

            self.cleanContactForm(inputsContacto);
            response = $.ajax({
              url: url,
              method: 'POST',
              data: data,
              beforeSend: function(xhr) {
                self.$submitButtonContact.attr('disabled', true);
                self.$submitButtonContact.text('Enviando Consulta...');
                if (!self.checkInputErrors(inputsContacto)) {
                  xhr.abort();
                }
              }
            });

            response.done(function(data, textStatus, xhr) {
              //save and show camisas
              self.cleanContactForm(inputsContacto);
              self.successResultsContactCamisa(data);
              inputsContacto.val('');
              setTimeout(function() {
                self.$modalConsulta.modal('hide');
                self.cleanContactForm(inputsContacto);
              }, 800);
            });

            response.fail(function(xhr, textStatus, err) {
              self.errorResultsContactCamisa(xhr, inputsContacto);
            });
          });

          this.$cancelSubmitButtonContact.on('click', function() {
            self.$contactCamisaForm.find('input').val('');
            self.cleanContactForm();
          });
        },
        cleanContactForm: function(inputs) {
          this.$contactCamisaForm.find('.help-block, .alert').remove();
          this.$contactCamisaForm.find('.has-error').removeClass('has-error');
        },
        successResultsContactCamisa: function(data) {
          var successMsg = '<div class=\"alert alert-success alert-dismissible\" role=\"alert\">' +
            '<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">'+
            '<span aria-hidden=\"true\">&times;</span></button>'+
            '%message%</div>';

          this.$contactCamisaForm.prepend(successMsg.replace('%message%', 'Consulta enviada con éxito'));
          this.resetSubmitButtonContact();
        },
        errorResultsContactCamisa: function(xhr, inputsContacto) {
          var err = {},
            inputErrParent,
            errorMsg = '<div class=\"alert alert-danger alert-dismissible\" role=\"alert\">' +
            '<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">'+
            '<span aria-hidden=\"true\">&times;</span></button>'+
            '%message%</div>',
            inputErr;

          this.$contactCamisaForm.find('.modal-body').prepend(errorMsg.replace('%message%', 'No se ha podido enviar la consulta. Debes completar los datos.'));
          this.resetSubmitButtonContact();
        },
        resetSubmitButtonContact: function() {
          this.$submitButtonContact.attr('disabled', false);
          this.$submitButtonContact.text('Enviar Consulta');
        },
        checkInputsBusqueda: function(inputsBusqueda) {
          //check input data errors beforeSend
          var val,
            self = this,
            retorno = true,
            dataType,
            inputErrParent,
            formError = '<div class=\"alert alert-warning alert-dismissible\"'+
            'role=\"alert\"><button type=\"button\" class=\"close\"'+
            'data-dismiss=\"alert\" aria-label=\"Cerrar\">'+
            '<span aria-hidden=\"true\">&times;</span></button>'+
            '<span class=\"glyphicon glyphicon-exclamation-sign\"'+
            'aria-hidden=\"true\"></span><strong>Atención</strong> Debe completar al menos un dato</div>';

          if ($(inputsBusqueda[0]).val() == '' && $(inputsBusqueda[1]).val() == '' && $(inputsBusqueda[2]).val() == '' ) {
            this.$buscadorCamisaForm.append(formError);
            retorno = false;
          } else {
            var inputsWithValues = inputsBusqueda.filter(function(index, element) {
              return $(element).val() != '';
            });
            retorno = self.checkInputErrors(inputsWithValues);
          }
          return retorno;
        },
        printErrorMessage: function(input) {
          var inputErrParent = $(input).parent(),
              inputErrMsg = '<div class="help-block with-errors"><small>%message%</small></div>';
          //check if parent already has message printed
          if (!inputErrParent.hasClass('has-error')) {
            inputErrParent.addClass('has-error');
            inputErrParent.append(inputErrMsg.replace('%message%', $(input).data('error')));
          }
        },
        checkInputErrors: function(inputs) {
          var self = this,
              retorno = true;
          inputs.each(function(index, element) {
            var val = $(element).val(),
                inputErrMsg = '<div class="help-block with-errors"><small>%message%</small></div>',
                dataType = $(element).data('type');
            switch(dataType) {
              case 'text':
                if (!isNaN(val)) {
                  self.printErrorMessage(element);
                  retorno = false;
                }
                break;
              case 'number':
                if (isNaN(val) || val == '') {
                  self.printErrorMessage(element);
                  retorno = false;
                }
                break;
            }
          });
          return retorno;
        },
        successResultsBusqueda: function(data, textStatus, xhr) {
          //clear old results
          if (this.$resultadoBusquedaContent.children().length > 0) {
            this.$resultadoBusquedaContent.empty();
          }
          //process correct data from Server
          appController.camisa.saveCamisas(JSON.parse(data));
        },
        errorResultsBusqueda: function() {
          //process errors from Server
        },
        cleanFormBusqueda: function() {
          this.$buscadorCamisaForm.find('.help-block, .alert').remove();
          this.$buscadorCamisaForm.find('.has-error').removeClass('has-error');
          this.$submitButtonBuscador.attr({'disabled': true, 'title': 'Buscando'}).addClass('loading');
        },
        resetSubmitButtonBusqueda: function() {
          this.$submitButtonBuscador.attr({'disabled': false, 'title': 'Buscar'}).removeClass('loading');
        },
        render: function() {
          var results = appController.camisa.getCamisas(),
              resultadoTitleHTML = 'Se encontraron %cantidad-camisas% camisas',
              resultadoTitleEmptyHTML = 'No se encontraron camisas que coincidan con la búsqueda',
              formConsulta = this.$contactCamisaForm,
              modalConsulta = this.$modalConsulta,
              self = this,
              $column,
              column,
              panel,
              title,
              processedContent,
              $buttonModal = $('<button type=\"button\" class=\"btn ' +
              'btn-primary btn-sm\" data-toggle=\"modal\"'+
              'data-camisa-id="%camisa-id%" data-camisa-cod="%camisa-cod%"'+
              'data-target=\"#modal-consulta\">' +
              'Consultar' + '</button>'),
              resultadoVacioHTML = '<div class=\"alert alert-warning\">No se encontraron resultados</div>',
              resultadoItemColumnHTML = '<div class=\"col-xs-6 col-sm-4 col-md-3\">%column%</div>',
              resultadoItemPaneHTML = '<div class=\"panel panel-primary panel-busqueda\">' +
              '<div class=\"panel-heading\"><h3 class=\"panel-title\">%title%</h3>'+
              '</div> <div class=\"panel-body\">%panelContent%</div><div ' +
              'class=\"panel-footer text-center\"></div></div>',
              resultadoItemContentHTML = '<ul class=\"list-unstyled\">%dataContent%</ul>';

          if (this.$resultadoBusquedaContent.children().length > 0) {
            //clear old data
            this.$resultadoBusquedaContent.empty();
          }

          if (results.length == 0) {
            //empty data
            this.$resultadoBusquedaContent.append(resultadoVacioHTML);
            this.$resultadoBusquedaTitle.html(resultadoTitleEmptyHTML);
          } else {
            results.forEach(function(element, index) {
              var dataContent = '',
                  camisaId = element.id,
                  $buttonModalClone = $buttonModal.clone(),
                  camisaCodigo;
                  title = 'Código : ' + element.codigo;

              for (var property in element) {
                if (element.hasOwnProperty(property)) {
                  if (element[property] != null) {

                    if (property == 'marcas') {
                      var marcasList = '';
                      element[property].forEach(function(elem, index){
                        marcasList += elem.nombre + '&nbsp;';
                      });
                      dataContent += '<li class="item-separator"><b>' + property + '</b>&nbsp;' + marcasList + '</li>'
                    } else if (property != 'id' &&  property != 'codigo' && property != 'activo') {
                      if (property == 'valonaDiametro' || property == 'valonaAltura') {
                        var newPropertyOne = property.substr(0, 6);
                        var newPropertyTwo = property.substr(6);
                        if (newPropertyTwo == 'Diametro') {
                          newPropertyTwo = newPropertyTwo.replace('a', 'á');
                        }
                        dataContent += '<li class="item-separator"><b>' + newPropertyTwo + ' ' + newPropertyOne + '</b>&nbsp;' + element[property] + '</li>'
                      } else if (property == 'paraLlamas') {
                        dataContent += '<li class="item-separator"><b>'  + property + '</b>&nbsp;' + element[property] + '</li>'
                      } else {
                        dataContent += '<li class=""><b>' + property + '</b>&nbsp;' + element[property] + '</li>'
                      }
                    }
                  }
                }
              }

              $buttonModalClone.on('click', function() {
                formConsulta.find('#camisa-id').val(element.id);
                modalConsulta.find('.modal-title').find('span').html(element.codigo);
              });

              processedContent = resultadoItemContentHTML.replace('%dataContent%', dataContent);
              panel = resultadoItemPaneHTML.replace('%panelContent%', processedContent).replace('%title%', title);
              // panel = panel.replace('%camisa-id%', camisaId).replace('%camisa-cod%', camisaCodigo);
              column = resultadoItemColumnHTML.replace('%column%', panel);
              $column = $(column);
              $column.find('.panel-footer').append($buttonModalClone);
              self.$resultadoBusquedaContent.append($column);
            });

            this.$resultadoBusquedaTitle.html(resultadoTitleHTML.replace('%cantidad-camisas%', results.length));
          }
          this.$resultadoBusquedaContent.closest('.search-result-container').fadeIn('slow');
          this.resetSubmitButtonBusqueda();
        }
      },

      init: function() {
        this.global.init();
        this.map.init();
        this.camisa.init();
      },
    }

    appController.init();
  }(jQuery);
});
